import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import markersDataDev from './json/markers.dev.json'
import markersDataProd from './json/markers.prod.json'
const markersData = import.meta.env.PROD ? markersDataProd : markersDataDev

import { RootState } from '@src/redux/store.ts' // JSON 파일 불러오기
export type MarkerType = 'whale' | 'garbage' | 'toilet' | 'bus' | 'subway' | 'stairway' | 'ramp' | 'elevator' | ''
export type Marker = {
  id: number
  lat: number
  lng: number
  type: MarkerType
  detail?: string | null
  stationNum?: string | null
}

export type SelectMarker = {
  id: number
  type: MarkerType
  distance: number
  detail?: string | null
}

type StateType = {
  markers: Marker[]
  select: SelectMarker | null
}

const initialState: StateType = {
  markers: markersData as Marker[],
  select: null,
}

const mapMarkerSlice = createSlice({
  name: 'mapMarker',
  initialState,
  reducers: {
    /** 목적지 마커 선택 **/
    selectMarker(state, action: PayloadAction<Marker>) {
      const { id, type, detail } = action.payload

      if (state.select) {
        state.select.id = id
        state.select.type = type
        state.select.detail = detail
      } else {
        state.select = {
          id: id,
          type: type,
          distance: 0,
          detail: detail ? detail : null,
        }
      }
    },

    /** 목적지 마커의 나와의 위치 적용 **/
    setSelectMarkerDistance(state, action: PayloadAction<{ marker: Marker; distance: number }>) {
      const { marker, distance } = action.payload
      if (marker.id === state.select?.id) {
        state.select.distance = distance
      } else {
        if (state.select) {
          state.select.distance = -404
        }
      }
    },

    clearSelectMarker(state) {
      state.select = null
    },
  },
})

export const { selectMarker, setSelectMarkerDistance, clearSelectMarker } = mapMarkerSlice.actions

export const mapMarkersSelector = (state: RootState) => state.mapMarkers

export default mapMarkerSlice.reducer
